import { render, staticRenderFns } from "./BannerHeroForm.vue?vue&type=template&id=115edd03&scoped=true&"
import script from "./BannerHeroForm.vue?vue&type=script&lang=js&"
export * from "./BannerHeroForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerHeroForm.vue?vue&type=style&index=0&id=115edd03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115edd03",
  null
  
)

export default component.exports